import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from "./locals"
import "./styles.less"
import directives from "./utils/directive"
import vant from 'vant'
import 'vant/lib/index.css'
import axios from 'axios';
import VueMeta from 'vue-meta'
import "@/assets/fonts/index.less"
import {adjustFontSize} from "@/utils/autoSize.js";
import { createId } from "@/utils/index.js";
import { insertCallback } from "@/utils/windowResize";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { getSeoInfo } from "@/api/index.js"

insertCallback(createId(), adjustFontSize, true);

Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.use(VueMeta)
Vue.use(vant)
for (const [key, opt] of directives) {
  Vue.directive(key, opt)
}


new Vue({
  i18n,
  el: '#app',
  router,
  data() {
    return {
      description: '',
      keywords:'',
    };
  },
  mounted(){
    this.getLeftList()
  },
  methods:{
    getLeftList() {
      getSeoInfo()
        .then((res) => {
          this.keywords = res.data.data.value
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  metaInfo(){
    return{
      title:'2026上海区块链国际周',
      meta:[
        {name:'description',content:'2026上海区块链国际周'},
        {name:'keywords',content:this.keywords},
      ]
    }
  },
  render: (h) => h(App),
})
